import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carpooling',
  templateUrl: './carpooling.component.html',
  styleUrls: ['./information.component.css']
})
export class CarpoolingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
